<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Zjr4O/tc-custom/9780374711689.jpg?1731054738093" alt="This image is the cover for the book Odd Woman and the City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Odd Woman and the City
      </h1>
      <p class="bookDescription body article font2">
        <b>“Funny and elegiac and truth-dealing. . . . Ms. Gornick gets into the fat of feeling. She is as good a writer about friendship as we have.” —<i>New York Times</i></b><br/><br/>A memoir of self-discovery and the dilemma of connection in our time, <i>The Odd Woman and the City</i> explores the rhythms, chance encounters, and ever-changing friendships of urban life that forge the sensibility of a fiercely independent woman who has lived out her conflicts, not her fantasies, in a city that has done the same. Running steadily through the book is Vivian Gornick’s exchange of more than twenty years with Leonard, a gay man who is sophisticated about his own unhappiness. The exchange between Gornick and Leonard acts as a Greek chorus to the main action of the narrator’s continual engagement on the street with grocers, derelicts, and doormen; people on the bus, cross-dressers on the corner, and acquaintances by the handful. In Leonard she sees herself reflected plain; out on the street she makes sense of what she sees.<br/><br/>Written as a narrative collage that includes meditative pieces on the making of a modern feminist, the role of the flaneur in urban literature, and the evolution of friendship over the past two centuries, <i>The Odd Woman and the City</i> beautifully bookends Gornick’s acclaimed <i>Fierce Attachments</i>, in which we first encountered her rich relationship with the ultimate metropolis.<br/><br/>“Stirring.” —<i>Los Angeles Times</i><br/><br/>“The best books . . . make us feel understood. . . . <i>The Odd Woman and the City </i>can be read as a guidebook for how to exist.” —<i>Los Angeles Times Review of Books</i><br/><br/>“Sharply observed.” —<i>The New Yorker</i><br/><br/>“One of the most vital and indispensable essayists of our cultural moment.” —Phillip Lopate<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivian Gornick
      </h2>
      
      <p class="authorDescription body article"><P><B>Vivian Gornick</B> is the bestselling author of the acclaimed memoir <I>Fierce Attachments</I>, a biography of Emma Goldman, and three essay collections: <I>The Men in My Life</I>, <I>Approaching Eye Level</I>, and <I>The End of the Novel of Love</I>, which was a finalist for the National Book Critics Circle Award.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a163cde0